import { createSelector, createFeatureSelector } from '@ngrx/store';
import { RouterReducerState } from '@ngrx/router-store';
import { Params } from '@angular/router';

/**
 * Minimal router state stored in the NgRx store.
 * Produced by CustomSerializer in the app and read by RouterFacade selectors.
 */
export interface SerializedRouterState {
  url: string;
  params: Params;
  queryParams: Params;
  fragment: string | null;
  data: Record<string, unknown>;
}

// Feature selector
const selectRouterFeature =
  createFeatureSelector<RouterReducerState<SerializedRouterState>>('router');

// Base selectors matching CustomSerializer's flat shape
const selectRouterState = createSelector(
  selectRouterFeature,
  (router) => router?.state,
);

export const selectUrl = createSelector(
  selectRouterState,
  (state) => state?.url ?? '',
);

export const selectFragment = createSelector(
  selectRouterState,
  (state) => state?.fragment ?? null,
);
export const selectParams = createSelector(
  selectRouterState,
  (state) => state?.params ?? {},
);

export const selectQueryParams = createSelector(
  selectRouterState,
  (state) => state?.queryParams ?? {},
);

export const selectData = createSelector(
  selectRouterState,
  (state) => state?.data ?? {},
);
